import { authorizedRequest } from "../../../services/apiClient";
import type { PaginationParams } from "@/types/api";
import { buildQueryString } from "../../../utils/queryParams";

export type ActorType = "user" | "service" | "api_key" | "system";

export interface AuditLog {
  id: string;
  occurred_at: string;
  actor_type: ActorType;
  actor_id?: string | null;
  workspace_id?: string | null;
  action: string;
  resource_type: string;
  resource_id?: string | null;
  request_id?: string | null;
  ip_address?: string | null;
  metadata?: Record<string, unknown> | null;
}

export interface AuditLogListResponse {
  logs: AuditLog[];
  total_count: number;
  limit: number;
  offset: number;
}

export interface ActivityFeedEntry {
  id: string;
  occurred_at: string;
  actor_type: ActorType;
  actor_id?: string | null;
  workspace_id?: string | null;
  action: string;
  resource_type: string;
  resource_id?: string | null;
  summary: string;
}

export interface ActivityFeedResponse {
  activities: ActivityFeedEntry[];
  total_count: number;
  limit: number;
  offset: number;
}

export interface ListAuditLogsParams extends PaginationParams {
  workspace_id?: string;
  actor_id?: string;
  resource_type?: string;
  resource_id?: string;
  action?: string;
  actor_type?: ActorType;
  created_before?: string;
  created_after?: string;
  sort_desc?: boolean;
}

export async function listAuditLogs(
  accessToken: string,
  params: ListAuditLogsParams = {}
): Promise<AuditLogListResponse> {
  const path =
    "/admin/audit-logs" +
    buildQueryString({
      workspace_id: params.workspace_id,
      actor_id: params.actor_id,
      resource_type: params.resource_type,
      resource_id: params.resource_id,
      action: params.action,
      actor_type: params.actor_type,
      created_before: params.created_before,
      created_after: params.created_after,
      limit: params.limit,
      offset: params.offset,
      sort_desc: params.sort_desc ?? true
    });

  return authorizedRequest<AuditLogListResponse>(accessToken, path);
}

export type ListPersonalActivityParams = PaginationParams;

export async function listPersonalActivity(
  accessToken: string,
  params: ListPersonalActivityParams = {}
): Promise<ActivityFeedResponse> {
  const path =
    "/me/activity" +
    buildQueryString({
      limit: params.limit,
      offset: params.offset
    });

  return authorizedRequest<ActivityFeedResponse>(accessToken, path);
}
